import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import TermsConditions from '../Components/TermsConditions';
import TechLayout from './TechLayout';
import NavBarTech from './NavBarTech';

const TermsAndConditionsTech = () => (
    <Box>
<TechLayout>
      <Box bgColor={"black"} textColor={"white"} p={4}>
        <TermsConditions />
      </Box>
  </TechLayout>
  </Box>
);

export default TermsAndConditionsTech;